import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import {ErrorBoundaryWrapper} from "../../../core/components/error-boundary/error-boundary-wrapper";
import classNames from "classnames";
import styles from "../styles/odds-comparison-widget.module.scss";

const OddsComparisonWidgetAsyncComponent = AsyncComponent(async () => import('./odds-comparison-widget' /* webpackChunkName: "odds-comparison-widget" */ ));

export const OddsComparisonWidgetAsync = (props) => {
  return <ErrorBoundaryWrapper isMandatory={!props.isPreview}>
    {
      props.isPreview && !props.shouldUseSuspense ? <OddsComparisonWidgetAsyncComponent {...props}/> : <React.Suspense fallback={<div className={classNames(styles.placeholder)}/>}>
        <OddsComparisonWidgetAsyncComponent {...props}/>
      </React.Suspense>
    }
  </ErrorBoundaryWrapper>
};
